import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Icons
import CreateIcon from "../Assets/create-icon.svg";
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import CreateClassItem from "../Components/ClassItem/CreateClassItem";
import { GET_CLASS_ITEM_PAGINATION } from "../Schema/ClassItem";
import ClassItemAction from "../Components/ClassItem/ClassItemAction";
import {
  SelectAcademicYear,
  SelectGrade,
  SelectGroup,
} from "../Components/Include/DynamicSelect";

export default function ClassroomNeededItem() {
  
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [gradeVal, setGradeVal] = useState({ id: "", title: "" });
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // console.log("first::", academicYearVal, gradeVal, groupVal)

  const { refetch } = useQuery(GET_CLASS_ITEM_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      academicYearId: academicYearVal?.id ? academicYearVal?.id : "",
      gradeId: gradeVal?.id ? gradeVal?.id : "",
      groupId: groupVal?.id ? groupVal?.id : "",
    },
    onCompleted: ({ getClassItemPagination }) => {
      console.log("getClassItemPagination",getClassItemPagination);
      setTableData(getClassItemPagination?.data);
      setPaginationData(getClassItemPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };
  // console.log("tableData", tableData);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">
            សម្ភារៈដែលថ្នាក់ត្រូវមាន
          </Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ឆ្នាំសិក្សា</Typography>
            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
              className="search-field"
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ថ្នាក់</Typography>
            <SelectGrade
              selectedVal={gradeVal}
              setSelectedVal={setGradeVal}
              academicYearId={academicYearVal?.id}
              disabled={academicYearVal?.id ? false : true}
              className="search-field"
            />
          </Grid>

          {/* <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ក្រុម</Typography>
            <SelectGroup
              selectedVal={groupVal}
              setSelectedVal={setGroupVal}
              isUse={true}
              className="search-field"
            />
          </Grid> */}

          <Box flexGrow={1} />

          <Grid item xs={6} sm={6} md={12} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <CreateClassItem
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="8%">ល.រ</TableCell>
              <TableCell className="header-title" width="15%">ឆ្នាំសិក្សា</TableCell>
              <TableCell className="header-title">ថ្នាក់រៀន</TableCell>
              <TableCell className="header-title">Remark</TableCell>
              <TableCell className="header-title-end" width="20%"></TableCell>
            </TableHead>

            {loading ? (
              <LoadingPage colSpan={5} />
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <EmptyData colSpan={5} />
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      // console.log("row::", row)
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.academicYearId?.academicYearInKhmer}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.gradeId?.gradeName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <ClassItemAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ============================= Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
